import React from "react";
import ReactJson from "react-json-view";
import PropTypes from "prop-types";

const CustomJsonView = ({ src }) => {
  return (
    <ReactJson
      src={src}
      name={false}
      indentWidth={2}
      displayDataTypes={false}
      displayObjectSize={false}
      theme="summerfruit:inverted"
    />
  );
};

CustomJsonView.propTypes = {
  src: PropTypes.object.isRequired,
};

export default CustomJsonView;
